import {FilterCategory, FilterCategoryType, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {FilterDropdown} from "@/components/filterDropdown/FilterDropdown.tsx";
import {
  GQL_MAINTENANCE_SCHEDULES_FILTER_LIST,
  GQL_MAINTENANCE_SERVICES_FILTER_LIST,
} from "@/lib/queries/maintenance.ts";
import {MaintenanceEventType} from "@/lib/types/maintenance.ts";

type EventLogFiltersProps = {
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
};

export const MaintenanceStatusFilters = [
  {
    key: MaintenanceEventType.OCCURRENCE_STARTED,
    display: "Maintenance Started",
  },
  {
    key: MaintenanceEventType.OCCURRENCE_COMPLETED,
    display: "Maintenance Ended",
  },
  {
    key: MaintenanceEventType.OCCURRENCE_CANCELED,
    display: "Maintenance Stopped",
  },
  {
    key: MaintenanceEventType.OCCURRENCE_REPLACED,
    display: "Maintenance Replaced",
  },
  {
    key: MaintenanceEventType.SCHEDULE_CREATED,
    display: "Schedule Created",
  },
  {
    key: MaintenanceEventType.SCHEDULE_PAUSED,
    display: "Schedule Paused",
  },
  {
    key: MaintenanceEventType.SCHEDULE_RESUMED,
    display: "Schedule Resumed",
  },
  {
    key: MaintenanceEventType.SCHEDULE_DELETED,
    display: "Schedule Deleted",
  },
  {
    key: MaintenanceEventType.NOTIFICATION_SENT,
    display: "Notification Sent",
  },
];

export const EventLogFilters = ({filterSets, onFilterSetChange}: EventLogFiltersProps) => {
  const filterFields: FilterCategory[] = [
    {
      key: "types",
      type: FilterCategoryType.ARRAY,
      display: "Status",
      options: MaintenanceStatusFilters,
    },
    {
      key: "schedule_ids",
      type: FilterCategoryType.GQL,
      display: "Schedule",
      graphql: GQL_MAINTENANCE_SCHEDULES_FILTER_LIST,
      sorted: true,
    },
    {
      key: "services",
      type: FilterCategoryType.GQL,
      display: "Checks",
      graphql: GQL_MAINTENANCE_SERVICES_FILTER_LIST,
      sorted: true,
    },
  ];

  return <FilterDropdown categories={filterFields} appliedFilterSets={filterSets} onApply={onFilterSetChange} />;
};
